export default __webpack_public_path__ + "static/media/Google Search Mobile.af3849f9.svg";